define.alias("shared/components/shared/media-item-modal", "media/components/shared/media-item-modal");